import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';

const QuoteItem = ({ children, ...rest }) => {
  return (
    <Box py={[3, 6]} borderBottom={1} borderColor="greys.alto" {...rest}>
      {children}
    </Box>
  );
};

QuoteItem.propTypes = {
  children: PropTypes.node,
};

QuoteItem.defaultProps = {
  children: null,
};

export default QuoteItem;
